import styled from 'styled-components'
import { colors, TYPOGRAPHY, spacing } from 'styles'

interface Props {
  lorem?: string
}

export const Aside = styled.aside<Props>`
  position: fixed;
  display: grid;
  align-content: start;
  grid-area: aside;
  min-height: 100vh;
  padding: 0 ${spacing.stack.nano} ${spacing.stack.xxs} ${spacing.stack.xxxs};
  z-index: 100;
  transform: translateX(-100vw);
  transition: all 300ms ease-out;
  padding-top: 1.25rem;

  @media screen and (min-width: 48em) {
    position: relative;
    width: auto;
    z-index: initial;
    transform: translateX(0);
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0.6rem 1rem;
`

export const AppVersion = styled.div`
  position: absolute;
  bottom: 5px;
  left: 10px;
  color: ${colors.content.subdued};
  font-size: ${TYPOGRAPHY.size.xxxxs};
`
